// ── Narrative helpers ──────────────────────────────────────────────────────
// The "explain, don't just display" primitives. Every page opens with a
// pageIntro() (what this screen is + how to read it). Use callout() for inline
// plain-English context, and statLine() for a headline metric with its meaning.

/** Page header: title + one-line purpose + optional "how to read this" blurb. */
// The re-envisioned page header: ONE line — title + a quiet purpose, with the
// how-to behind a ⓘ toggle. Data is the first thing on every screen; the old
// hero card (big emoji + paragraph + indigo callout) made every page open
// like a doc instead of a tool.
let _introSeq = 0;
export function pageIntro(opts: { title: string; purpose: string; howToRead?: string; icon?: string }): string {
  const id = `pi-${++_introSeq}-${Math.abs(opts.title.length * 7 + opts.purpose.length)}`;
  return `
    <div class="page-intro" style="margin:0 0 14px;">
      <div style="display:flex; align-items:baseline; gap:10px; flex-wrap:wrap;">
        <h2 style="margin:0; font-size:16px; font-weight:600; letter-spacing:-0.01em; color:var(--text);">${opts.title}</h2>
        <span style="font-size:12px; color:var(--text-muted);">${opts.purpose}</span>
        ${opts.howToRead ? `<button type="button" onclick="var e=document.getElementById('${id}');e.style.display=e.style.display==='none'?'':'none';"
          style="width:16px; height:16px; border-radius:999px; border:1px solid #d1d5db; background:#fff; color:var(--text-muted); font-size:10px; font-weight:600; line-height:1; cursor:pointer; flex-shrink:0;"
          title="How to read this">i</button>` : ''}
      </div>
      ${opts.howToRead ? `<div id="${id}" style="display:none; margin-top:8px; font-size:12px; color:var(--text-muted); line-height:1.55; max-width:760px; border-left:2px solid var(--border); padding-left:10px;">${opts.howToRead}</div>` : ''}
    </div>`;
}

/** Inline plain-English callout (tip / warning / info). */
export function callout(text: string, tone: 'info' | 'tip' | 'warn' = 'info'): string {
  const c = {
    info: { bg: '#eff6ff', bd: '#bfdbfe', fg: '#1e40af', icon: 'ℹ️' },
    tip:  { bg: '#f0fdf4', bd: '#bbf7d0', fg: '#166534', icon: '✅' },
    warn: { bg: '#fef2f2', bd: '#fecaca', fg: '#991b1b', icon: '⚠️' },
  }[tone];
  return `<div style="display:flex;gap:8px;align-items:flex-start;background:${c.bg};border:1px solid ${c.bd};
    border-radius:10px;padding:10px 12px;margin:8px 0;">
    <span>${c.icon}</span><span style="font-size:13px;color:${c.fg};line-height:1.5;">${text}</span></div>`;
}

/** Empty-state with explanation (never show a blank panel with no words). */
export function emptyState(title: string, explanation: string, icon = '📭'): string {
  return `<div style="text-align:center;padding:40px 20px;color:#94a3b8;">
    <div style="font-size:32px;margin-bottom:8px;">${icon}</div>
    <div style="font-size:15px;font-weight:600;color:#475569;margin-bottom:4px;">${title}</div>
    <div style="font-size:13px;max-width:420px;margin:0 auto;line-height:1.5;">${explanation}</div></div>`;
}
